export const GET_CHANNELS = {
  prefix: 'GET_CHANNELS',
  BEGIN: 'GET_CHANNELS_BEGIN',
  SUCCESS: 'GET_CHANNELS_SUCCESS',
  FAILURE: 'GET_CHANNELS_FAILURE'
}
